var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_7434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8505 58H17.7944L12 6H51.6449L45.8505 58Z",
    fill: "none",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1496 31.8543C29.5329 31.8543 30.6542 30.7329 30.6542 29.3496C30.6542 27.9664 29.5329 26.845 28.1496 26.845C26.7663 26.845 25.6449 27.9664 25.6449 29.3496C25.6449 30.7329 26.7663 31.8543 28.1496 31.8543Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.99 41.0323C40.3733 41.0323 41.4947 39.9109 41.4947 38.5276C41.4947 37.1443 40.3733 36.0229 38.99 36.0229C37.6067 36.0229 36.4854 37.1443 36.4854 38.5276C36.4854 39.9109 37.6067 41.0323 38.99 41.0323Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9908 48.5235C30.374 48.5235 31.4954 47.4021 31.4954 46.0188C31.4954 44.6355 30.374 43.5142 28.9908 43.5142C27.6075 43.5142 26.4861 44.6355 26.4861 46.0188C26.4861 47.4021 27.6075 48.5235 28.9908 48.5235Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4865 20.04H49.1593",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_7434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassWater);
export default __webpack_public_path__ + "static/media/glass-water.50e18131bec8935d480a30a98d276038.svg";
export { ForwardRef as ReactComponent };